export default __webpack_public_path__ + "static/media/amiensmini.5a0db2df.jpg";